export default __webpack_public_path__ + "static/media/person.2670cfa6.svg";